import React, { useState } from "react";
import Button from '../../components/Button';
import VideoPlayer from "../../components/VideoPlayer";

export default function ManiobrasDeglutoriasCompensatorias() {

  const [videoAbierto, setVideoAbierto] = useState(null);

  const abrirVideo = (url) => {
    setVideoAbierto(url);
  };

  const cerrarVideo = () => {
    setVideoAbierto(null);
  };

  return (
    <div className="p-4 max-w-xl mx-auto flex flex-col gap-4">

      {/* Encabezado */}
      <div className="flex items-center justify-center">
        <h4 className="font-bold text-center">Maniobras deglutorias compensatorias</h4>
      </div>

      {/* Introducción */}
      <div className="text-justify">
        <p className="mb-2">Las maniobras compensatorias deglutorias también pueden ayudar a evitar 
            las penetraciones y aspiraciones así como facilitar el paso del bolo, disminuir los 
            residuos faríngeos y aumentar el tiempo de apertura del Esfínter Esofágico Superior.
        </p>

        <p className="mb-4">Al realizarlos, es importante que el/la paciente permanezca sentado/a, 
            con la espalda recta, tranquilo, delante de un espejo y sin distracciones.
        </p>

        <p>A continuación, se presentan diferentes enlaces que llevan a maniobras que puede realizar:</p>
      </div>

      {/* Maniobras supraglótica -> Enlaces */}

      <div className="flex flex-col gap-4 mt-2 font-semibold bg-white border rounded-lg p-4">
        <a
          href="https://disfapp.es/maniobras-compensatorias-supraglotica"
          target="_blank"
          rel="noopener noreferrer"
          className="w-full"
        >
          <Button className="w-full">Maniobra supraglótica</Button>
        </a>

        {/* Video 01 */}
        <Button onClick={() => abrirVideo("/videos/maniobra-de-deglucion-forzada.mp4")}>
          Maniobra de deglución forzada (Video)
        </Button>

        {/* Video 02 */}
        <Button onClick={() => abrirVideo("/videos/maniobra-de-doble-deglucion.mp4")}>
          Maniobra de doble deglución (Video)
        </Button>
      </div>

      {/* Maniobra de Masako -> Enlaces */}

      <div className="flex flex-col gap-4 mt-2 font-semibold bg-white border rounded-lg p-4">
        <a
          href="https://disfapp.es/maniobras-compensatorias-masako"
          target="_blank"
          rel="noopener noreferrer"
          className="w-full"
        >
          <Button className="w-full">Maniobra de Masako</Button>
        </a>
      </div>

      {/* Maniobra de Mendelson -> Enlaces */}

      <div className="flex flex-col gap-4 mt-2 font-semibold bg-white border rounded-lg p-4">
        <a
          href="https://disfapp.es/maniobra-de-mendelson"
          target="_blank"
          rel="noopener noreferrer"
          className="w-full"
        >
          <Button className="w-full">Maniobra de Mendelson</Button>
        </a>
      </div>

      {/* Modal VideoPlayer */}
      {videoAbierto && (
        <VideoPlayer videoUrl={videoAbierto} onClose={cerrarVideo} />
      )}
    </div>
  );
}